<div
  class="checkout-card-header"
  [class.--small]="size() === 'small'"
  [class.--compact-actions]="inlineActionsFrom() === 'compact'"
>
  <div class="title">
    <h3>{{ title() }}</h3>
  </div>
  @if (hasMenu()) {
    <div class="menu-icon">
      <!-- Inline handlingsikoner: vises når der er bredde nok (se scss container-query). -->
      <span class="inline-actions">
        <ng-content select="[card-header-action]"></ng-content>
      </span>
      <button class="overflow-trigger" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Booking options">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <ng-content></ng-content>
      </mat-menu>
    </div>
  }
</div>
